var _path, _rect, _path2, _path3, _rect2, _g, _path4, _path5, _path6, _g2, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoPartnersData = function SvgNoPartnersData(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 301,
    viewBox: "0 0 321 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.45999C0.5 2.89223 3.39224 0 6.96 0H314.04C317.608 0 320.5 2.89224 320.5 6.46V300H0.5V6.45999Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 216.103,
    y: 19.3799,
    width: 26.6475,
    height: 62.1775,
    fill: "url(#paint0_linear_69_25743)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.337 173.995C145.167 173.527 144.018 165.868 142.965 162.096C137.443 159.43 126.094 155.288 124.868 160.048C123.336 165.998 126.783 169.509 128.411 170.192C129.713 170.738 130.549 170.094 130.804 169.704C130.996 170.387 131.858 171.752 133.773 171.752C135.688 171.752 136.422 170.257 136.549 169.509C137.06 171.167 138.733 174.386 141.337 173.995Z",
    fill: "#90CAF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.496 161.802C140.379 162.094 150.624 168.434 153.21 164.728C156.083 157.998 137.028 150 121.995 150C94.8016 150 52.0011 178.285 34 192.427L34 261.189C43.4793 242.853 97.1954 191.647 109.547 184.235C121.899 176.822 127.931 183.552 133.389 182.967C138.847 182.381 136.74 177.505 135.496 176.139C134.251 174.774 125.921 173.018 125.155 168.532C124.389 164.045 130.612 161.509 135.496 161.802Z",
    fill: "url(#paint1_linear_69_25743)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3853,
    y: 265.961,
    width: 22.8587,
    height: 88.6604,
    transform: "rotate(-180 55.3853 265.961)",
    fill: "url(#paint2_linear_69_25743)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.8777,
    y: 147.248,
    width: 117.201,
    height: 40.8778,
    transform: "rotate(90 41.8777 147.248)",
    fill: "url(#paint3_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.1972,
    cy: 158.424,
    rx: 11.1764,
    ry: 11.8162,
    transform: "rotate(90 42.1972 158.424)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.2231,
    cy: 168.694,
    rx: 11.1764,
    ry: 11.8162,
    transform: "rotate(90 49.2231 168.694)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1293,
    cy: 168.695,
    rx: 11.1764,
    ry: 12.1356,
    transform: "rotate(90 36.1293 168.695)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.1972,
    cy: 158.424,
    rx: 11.1764,
    ry: 11.8162,
    transform: "rotate(90 42.1972 158.424)",
    fill: "url(#paint4_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5165,
    cy: 181.682,
    rx: 8.45782,
    ry: 8.94202,
    transform: "rotate(90 42.5165 181.682)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.726,
    cy: 215.213,
    rx: 10.5723,
    ry: 11.1775,
    transform: "rotate(90 37.726 215.213)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.281,
    cy: 197.088,
    rx: 12.9888,
    ry: 13.7324,
    transform: "rotate(90 40.281 197.088)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.281,
    cy: 197.088,
    rx: 12.9888,
    ry: 13.7324,
    transform: "rotate(90 40.281 197.088)",
    fill: "url(#paint5_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7261,
    cy: 233.336,
    rx: 12.9888,
    ry: 13.7324,
    transform: "rotate(90 37.7261 233.336)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.0714,
    cy: 249.95,
    rx: 15.1033,
    ry: 15.9679,
    transform: "rotate(90 45.0714 249.95)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7261,
    cy: 233.336,
    rx: 12.9888,
    ry: 13.7324,
    transform: "rotate(90 37.7261 233.336)",
    fill: "url(#paint6_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9521,
    cy: 142.717,
    rx: 14.1971,
    ry: 15.0098,
    transform: "rotate(90 24.9521 142.717)",
    fill: "url(#paint7_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.2177,
    ry: 18.2034,
    transform: "matrix(4.2912e-08 -1 -1 -4.45257e-08 25.5906 268.981)",
    fill: "url(#paint8_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.2177,
    ry: 18.2034,
    transform: "matrix(4.2912e-08 -1 -1 -4.45257e-08 35.5039 283.281)",
    fill: "url(#paint9_linear_69_25743)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.193 153.617C177.785 153.914 174.874 147.425 173.719 144.143L187.396 136.434L194.417 137.362C194.691 139.406 194.654 143.623 192.32 144.143C189.986 144.663 187.761 140.211 186.94 137.92L186.211 138.105C186.667 139.313 187.633 142.489 187.852 145.536C188.126 149.344 185.025 149.623 183.475 148.415C183.749 150.737 183.202 153.245 180.193 153.617Z",
    fill: "#90CAF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.965 149.569C167.69 137.677 264.039 74.3008 276.912 69.5851L285.5 65C286.513 77.0632 284.903 105.392 285.5 112.5C237.75 119.212 204.449 154.709 200.986 157.05C197.522 159.392 195.635 155.449 196.35 153.059C197.064 150.669 205.092 147.105 199.47 142.264C193.848 137.423 178.401 149.625 176.641 151.544C174.88 153.463 168.14 157.105 167.965 149.569Z",
    fill: "url(#paint10_linear_69_25743)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.26 62.0898L286.261 62.0898V142.765H250.26V62.0898Z",
    fill: "url(#paint11_linear_69_25743)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.581,
    y: 172.479,
    width: 130.228,
    height: 36.4647,
    transform: "rotate(-90 267.581 172.479)",
    fill: "url(#paint12_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.296,
    cy: 160.061,
    rx: 12.4187,
    ry: 10.5406,
    transform: "rotate(-90 267.296 160.061)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.028,
    cy: 148.649,
    rx: 12.4187,
    ry: 10.5406,
    transform: "rotate(-90 261.028 148.649)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.708,
    cy: 148.649,
    rx: 12.4187,
    ry: 10.8255,
    transform: "rotate(-90 272.708 148.649)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.296,
    cy: 160.061,
    rx: 12.4187,
    ry: 10.5406,
    transform: "rotate(-90 267.296 160.061)",
    fill: "url(#paint13_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.011,
    cy: 134.216,
    rx: 9.39793,
    ry: 7.97665,
    transform: "rotate(-90 267.011 134.216)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.284,
    cy: 96.9596,
    rx: 11.7474,
    ry: 9.97082,
    transform: "rotate(-90 271.284 96.9596)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.005,
    cy: 117.099,
    rx: 14.4325,
    ry: 12.2499,
    transform: "rotate(-90 269.005 117.099)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.005,
    cy: 117.099,
    rx: 14.4325,
    ry: 12.2499,
    transform: "rotate(-90 269.005 117.099)",
    fill: "url(#paint14_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.284,
    cy: 76.8223,
    rx: 14.4325,
    ry: 12.2499,
    transform: "rotate(-90 271.284 76.8223)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.732,
    cy: 58.3615,
    rx: 16.782,
    ry: 14.244,
    transform: "rotate(-90 264.732 58.3615)",
    fill: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.284,
    cy: 76.8223,
    rx: 14.4325,
    ry: 12.2499,
    transform: "rotate(-90 271.284 76.8223)",
    fill: "url(#paint15_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.679,
    cy: 177.514,
    rx: 15.7751,
    ry: 13.3894,
    transform: "rotate(-90 282.679 177.514)",
    fill: "url(#paint16_linear_69_25743)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 28.1106,
    ry: 24.1545,
    transform: "matrix(-0.163877 0.986481 0.974428 0.2247 292.857 33.6581)",
    fill: "url(#paint17_linear_69_25743)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.906 145.931C153.867 145.791 153.724 145.71 153.584 145.748C153.445 145.786 153.364 145.93 153.402 146.069L153.402 146.069C153.402 146.069 153.402 146.069 153.402 146.069C154.076 148.515 154.112 150.134 153.449 151.303C152.785 152.471 151.376 153.269 148.931 153.943C148.931 153.943 148.93 153.943 148.93 153.943C148.791 153.982 148.71 154.126 148.748 154.265C148.786 154.404 148.93 154.486 149.069 154.447C151.515 153.773 153.134 153.737 154.303 154.401C155.471 155.064 156.269 156.473 156.943 158.919C156.982 159.058 157.126 159.14 157.265 159.101C157.404 159.063 157.486 158.919 157.447 158.78C156.773 156.334 156.737 154.715 157.401 153.547C158.064 152.378 159.473 151.58 161.919 150.906C162.058 150.867 162.14 150.724 162.101 150.584C162.063 150.445 161.919 150.364 161.78 150.402C159.334 151.076 157.715 151.112 156.547 150.449C155.378 149.785 154.58 148.376 153.906 145.931C153.906 145.931 153.906 145.931 153.906 145.931Z",
    fill: "#2979FF",
    stroke: "#2979FF",
    strokeWidth: 0.522698,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.942 157.97C164.925 157.91 164.863 157.874 164.802 157.891C164.742 157.908 164.707 157.97 164.724 158.03C164.724 158.03 164.724 158.03 164.724 158.03C165.134 159.52 165.161 160.522 164.748 161.25C164.334 161.979 163.46 162.469 161.97 162.879C161.97 162.879 161.97 162.879 161.97 162.879C161.91 162.896 161.874 162.958 161.891 163.018C161.907 163.079 161.97 163.114 162.03 163.097C163.52 162.687 164.522 162.66 165.25 163.073C165.978 163.487 166.468 164.361 166.879 165.851C166.896 165.911 166.958 165.947 167.018 165.93C167.078 165.913 167.114 165.851 167.097 165.791C166.686 164.301 166.66 163.299 167.073 162.571C167.487 161.843 168.361 161.353 169.851 160.942C169.911 160.925 169.946 160.863 169.93 160.803C169.913 160.742 169.851 160.707 169.791 160.724C168.301 161.135 167.299 161.161 166.571 160.748C165.842 160.334 165.352 159.46 164.942 157.97C164.942 157.97 164.942 157.97 164.942 157.97Z",
    fill: "#2979FF",
    stroke: "#2979FF",
    strokeWidth: 0.226134,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_25743",
    x1: 242.75,
    y1: 48.0461,
    x2: 216.103,
    y2: 48.0461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_69_25743",
    x1: 87.9076,
    y1: 167.166,
    x2: 82.6871,
    y2: 157.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_69_25743",
    x1: 78.244,
    y1: 306.837,
    x2: 55.3853,
    y2: 306.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_69_25743",
    x1: 101.314,
    y1: 161.734,
    x2: 101.314,
    y2: 184.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_69_25743",
    x1: 42.1972,
    y1: 146.608,
    x2: 42.1972,
    y2: 170.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_69_25743",
    x1: 40.281,
    y1: 183.356,
    x2: 40.281,
    y2: 210.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_69_25743",
    x1: 37.7261,
    y1: 219.604,
    x2: 37.7261,
    y2: 247.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_69_25743",
    x1: 24.9521,
    y1: 127.707,
    x2: 12.5069,
    y2: 147.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_69_25743",
    x1: 17.2177,
    y1: 0,
    x2: 2.12456,
    y2: 24.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_69_25743",
    x1: 17.2177,
    y1: 0,
    x2: 2.12456,
    y2: 24.4729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_69_25743",
    x1: 237.072,
    y1: 110.586,
    x2: 229.982,
    y2: 98.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_69_25743",
    x1: 286.261,
    y1: 99.2844,
    x2: 250.26,
    y2: 99.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_69_25743",
    x1: 333.623,
    y1: 185.402,
    x2: 333.623,
    y2: 205.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_69_25743",
    x1: 267.296,
    y1: 149.52,
    x2: 267.296,
    y2: 170.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_69_25743",
    x1: 269.005,
    y1: 104.849,
    x2: 269.005,
    y2: 129.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_69_25743",
    x1: 271.284,
    y1: 64.5725,
    x2: 271.284,
    y2: 89.0722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F4FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_69_25743",
    x1: 282.679,
    y1: 164.125,
    x2: 272.799,
    y2: 184.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_69_25743",
    x1: 28.1106,
    y1: 0,
    x2: 10.154,
    y2: 35.8246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoPartnersData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-partners-data.86b71f90906a42438b36b53dc3dc7129.svg";